module.exports = __webpack_public_path__ + "img/mobile.305ea710.png";